import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {NavigationBehaviorOptions, Router} from '@angular/router';

import {APP_403, APP_ENTITY_ASSETS, APP_ENTITY_BANKING, APP_ENTITY_INVESTMENTS, APP_ENTITY_LOANS} from '../../config/app-urls';
import {AppParameterMap} from '../../config/app-parameter-map';
import {AppRoute} from '../../config/app-route';
import {UserSessionService} from '@shared/services/user-session.service';

@Component({
    selector: 'app-entity-holdings',
    templateUrl: './entity-holdings.component.html',
    styleUrls: ['./entity-holdings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class EntityHoldingsComponent implements OnInit {

    private readonly _router = inject(Router);
    private readonly _userSessionService = inject(UserSessionService);

    ngOnInit(): void {
        const route = this.selectFirstAuthorizedRoute();
        const params = AppParameterMap.from(this._router);
        const routeCommands = route.toRouterLinkCommands(params)
        this.redirect(routeCommands);
    }

    private selectFirstAuthorizedRoute(): AppRoute {
        const userSession = this._userSessionService.userSession;

        if (userSession.authorizations.banking) {
            return APP_ENTITY_BANKING;
        }

        if (userSession.authorizations.investments) {
            return APP_ENTITY_INVESTMENTS;
        }

        if (userSession.authorizations.assets) {
            return APP_ENTITY_ASSETS;
        }

        if (userSession.authorizations.loans) {
            return APP_ENTITY_LOANS;
        }

        return APP_403;
    }

    private redirect(commands: string[]): void {
        const options: NavigationBehaviorOptions = {
            replaceUrl: true
        };

        this._router.navigate(commands, options);
    }
}
